"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.phoneValid = exports.PHONE_NUMBER_REGEX = void 0;
exports.PHONE_NUMBER_REGEX = /^\+?\d{10,14}$/;
const phoneValid = (phone) => {
    var _a;
    if (typeof phone === 'string') {
        const getNumbers = (_a = phone.match(/\d/g)) === null || _a === void 0 ? void 0 : _a.join('');
        const phoneContainsLetters = /\D/g.test(phone.replace(/\+/, ''));
        if (phoneContainsLetters)
            return false;
        if (getNumbers) {
            return exports.PHONE_NUMBER_REGEX.test(getNumbers);
        }
    }
    return false;
};
exports.phoneValid = phoneValid;
